<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12VxQta/tc-custom/9781250221667.jpg?1721057728899" alt="This image is the cover for the book Switchback"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Switchback
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An epic YA adventure story about two friends lost in the Canadian wilderness from Danika Stone, the author of <i>All the Feels</i>.</b><br/><br/>Vale loves to hike, but kind of hates her classmates. Ash is okay with his classmates, but kind of hates the outdoors. So, needless to say they are both fairly certain that the overnight nature hike with their PE class is going to be a hellish experience. But when they get separated from the group during a storm, they have worse things to worry about than bullies and blisters. <br/><br/> Lost in the Canadian wilderness with limited supplies, caught in dangerous weather conditions, and   surrounded by deadly wildlife, it's going to take every bit of strength, skill, and luck they can muster to survive.<br/><br/><b>Chosen as one of the best young adult books of 2019 by the Canadian Children's Book Centre (Fall 2019 edition)</b><b><br/><br/>Praise for Danika Stone:</b><br/> "An enjoyable, fast-paced read." — <i>School Library Journal</i> on <i>Internet Famous<br/><br/></i>"The book is a dream. I loved absolutely everything about it. ... From the chapter headers to every mention of nerd culture, <i>All the Feels</i> is a blast!" —<i>Seeking Book Boyfriends</i> on <i>All the Feels</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Danika Stone
      </h2>
      
      <p class="authorDescription body article"><B>Danika Stone</B> is an author, artist, and educator who discovered a passion for writing fiction while in the throes of her Masters thesis. A self-declared bibliophile, Danika now writes novels for both adults (<I>Edge of Wild</I> and <I>The Dark Divide</I>) and teens (<I>All the Feels</I>, <I>Internet Famous, </I>and <I>Switchback</I>). When not writing, Danika can be found hiking in the Rockies, planning grand adventures, and spending far too much time online. She lives with her husband, three sons, and a houseful of imaginary characters in a windy corner of Alberta, Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel & Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4065b348